export const CLOSE_ERROR_DIALOG =
  'containers/quickview/errorDialog/CLOSE_ERROR_DIALOG'
